import { NgClass } from '@angular/common';
import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BreadcrumbItem } from '@scalefast/core';
import { ContentfulCloudinaryImage } from '../../../../core/interfaces/Contentful/CloudinaryImage/ContentfulCloudinaryImage';
import { ContentfulLayoutZoneBlockContent } from '../../../../core/interfaces/Contentful/LayoutZone/ContentfulLayoutZoneContent';

import { AppContentfulCloudinaryImageComponent } from '../contentful-cloudinary-image/contentful-cloudinary-image.component';
import { AppContentfulCloudinaryPictureComponent } from '../contentful-cloudinary-picture/contentful-cloudinary-picture.component';
import { AppContentfulCloudinaryVideoComponent } from '../contentful-cloudinary-video/contentful-cloudinary-video.component';
import { AppContentfulLandingPageSectionBodyComponent } from '../contentful-landing-page-section-body/contentful-landing-page-section-body.component';
import { ContentfulBaseService } from 'src/app/shared/services/contentful-base.service';

@Component({
  selector: 'app-contentful-landing-page-section',
  templateUrl: './contentful-landing-page-section.component.html',
  styleUrls: ['./contentful-landing-page-section.component.scss'],
  imports: [
    AppContentfulCloudinaryPictureComponent,
    AppContentfulLandingPageSectionBodyComponent,
    NgClass,
    AppContentfulCloudinaryVideoComponent,
    AppContentfulCloudinaryImageComponent,
  ],
  standalone: true,
})
export class AppContentfulLandingPageSectionComponent implements OnChanges {
  @Input() contentfulCategory?: ContentfulLayoutZoneBlockContent;
  @Input() articleBreadcrumbs: BreadcrumbItem | undefined;
  @Input() whiteText: boolean = false;
  @Input() aligned: 'left' | 'right' = 'left';
  @Input() index: number = 0;
  @Input() classToAdd: string = '';
  backgroundImageAsset: ContentfulCloudinaryImage | undefined;
  mobileBackgroundImageAsset!: ContentfulCloudinaryImage;
  heroImage!: ContentfulCloudinaryImage;
  #contentfulBaseService = inject(ContentfulBaseService);

  ngOnChanges(changes: SimpleChanges): void {
    const currentValue = changes.contentfulCategory?.currentValue;

    if (currentValue && this.contentfulCategory) {
      if (this.contentfulCategory.backgroundImageAsset) {
        this.backgroundImageAsset =
          this.contentfulCategory.backgroundImageAsset ??
          this.#contentfulBaseService.getDefaultImageAssetUrl('No background image asset found.');
      }
      if (this.contentfulCategory.backgroundImageMobileAssetUrl) {
        this.mobileBackgroundImageAsset =
          this.contentfulCategory.backgroundImageMobileAssetUrl ??
          this.#contentfulBaseService.getDefaultImageAssetUrl('No mobile background image asset found.');
      }
      if (this.contentfulCategory.heroImage) {
        this.heroImage =
          this.contentfulCategory.heroImage ?? this.#contentfulBaseService.getDefaultImageAssetUrl('No hero image asset found.');
      }
    }
  }
}
